import React from "react";
import { Dialog, DialogContent, Button, CircularProgress } from "@mui/material";
import "../css/CancelFlightDialog.css";

const CancelFlightDialog = ({ open, onClickYes, onClose, isLoading }) => {
  return (
    <Dialog
      open={open ?? false}
      onClose={onClose}
      PaperProps={{
        className: "cancel-flight-dialog-container",
      }}
    >
      <DialogContent>
        <div className="cancel-flight-dialog-content">
          <div className="cancel-flight-dialog-title-container">
            <div className="cancel-flight-dialog-title">Cancel Flight</div>
            <div className="cancel-flight-dialog-subtitle">
              Do yo want to cancel this Flight? This operation can not be
              reverted
            </div>
          </div>
          <Button
            variant="contained"
            onClick={!isLoading ? onClickYes : null}
            endIcon={
              isLoading ? <CircularProgress size={30} color="inherit" /> : null
            }
          >
            Yes
          </Button>
          <Button variant="contained" className="no-button" onClick={onClose}>
            No
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default CancelFlightDialog;
